// ----------------------------------------------------------------------

export enum BulkMailAction {
    DELETE = "delete",
    MARK_AS_READ = "markAsRead",
    MARK_AS_UNREAD = "markAsUnread",
    MARK_AS_USER_PROCESSED = "markAsUserProcessed",
    MARK_AS_USER_UNPROCESSED = "markAsUserUnprocessed",
    MARK_AS_FOCUS = "markAsFocus",
    MARK_AS_UNFOCUS = "markAsUnfocus",
}

/**
 * Résultat d'une action de masse.
 * #1728 — `success` / `failed` sont exprimés en **uniqueMailvistaId** (`internetMessageId::parentFolderId`),
 * le même espace que les `uniqueMailvistaId[]` passés à `executeBulkAction` :
 *   • DELETE / READ : copie-précis (la copie exactement ciblée) ;
 *   • FOCUS / PROCESSED : canonique inbox (ces actions sont inbox-only).
 */
export type BulkActionResult = {
    success: string[];
    failed: string[];
};
